import { Fragment, useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import { VerifyOldPassword, UpdatePassword } from "../../apis/UserManagement";
import Swal from "sweetalert2";
import { FormHelperText } from "@mui/material";

const ChangePassword = () => {
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isOldPassCorrect, setIsOldPassCorrect] = useState(false);

  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  const clearValues = () => {
    setOldPass("");
    setNewPass("");
    setConfirmPass("");
    setNotMatched(false);
    setIncomplete(false);
  };

  useEffect(() => {
    checkMatch();
  }, [newPass, confirmPass]);

  const [notMatched, setNotMatched] = useState(false);
  const [incomplete, setIncomplete] = useState(false);

  const checkMatch = () => {
    if (newPass != "" && confirmPass != "") {
      if (newPass != confirmPass) setNotMatched(true);
      else setNotMatched(false);
    } else setNotMatched(false);
  };

  const handleSave = () => {
    if (oldPass != "" && newPass != "" && confirmPass != "") {
      if (!notMatched) {
        let credentials = JSON.parse(localStorage.getItem("mag_credentials"));
        VerifyOldPassword(oldPass, credentials.user.user_id, (response) => {
          if (response.status === true) {
            UpdatePassword(credentials.user.user_id, newPass, (response) => {
              if (response.status === true) {
                clearValues();
                Swal.fire({
                  icon: "success",
                  title: "Success!",
                  text: "Password successfully changed",
                  confirmButtonColor: "#1976d2",
                  confirmButtonText: "OK",
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Error changing password (Report to the devs)",
                  confirmButtonColor: "#1976d2",
                  confirmButtonText: "OK",
                });
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Error changing password (Old password is incorrect)",
              confirmButtonColor: "#1976d2",
              confirmButtonText: "OK",
            });
          }
        });
      }
    } else setIncomplete(true);
  };

  return (
    <Fragment>
      <Grid
        container
        spacing={5}
        sx={{ paddingTop: 8 }}
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12}>
          <Typography variant="h3" style={{ fontWeight: 500 }}>
            Change Password
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <InputLabel
            htmlFor="outlined-basic"
            sx={{ textAlign: "left" }}
            error={incomplete && oldPass == ""}
          >
            Old Password
          </InputLabel>
          <OutlinedInput
            error={incomplete && oldPass == ""}
            id="outlined-basic"
            onChange={(e) => {
              setOldPass(e.target.value);
            }}
            type={showOldPassword ? "text" : "password"}
            value={oldPass}
            defaultValue={oldPass}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => {
                    setShowOldPassword(!showOldPassword);
                  }}
                  onMouseDown={() => {}}
                  edge="end"
                >
                  {showOldPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            sx={{ width: "50vh" }}
          />
          <FormHelperText error={incomplete && oldPass == ""}>
            {incomplete && oldPass == "" ? "required" : ""}
          </FormHelperText>
        </Grid>
        <Grid item xs={12}>
          <InputLabel
            htmlFor="outlined-basic-new"
            sx={{ textAlign: "left" }}
            error={notMatched || (incomplete && newPass == "")}
          >
            New Password
          </InputLabel>
          <OutlinedInput
            error={notMatched || (incomplete && newPass == "")}
            id="outlined-basic-new"
            onChange={(e) => {
              setNewPass(e.target.value);
            }}
            type={showNewPassword ? "text" : "password"}
            value={newPass}
            defaultValue={newPass}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => {
                    setShowNewPassword(!showNewPassword);
                  }}
                  onMouseDown={() => {}}
                  edge="end"
                >
                  {showNewPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            sx={{ width: "50vh" }}
          />
          <FormHelperText error={notMatched || (incomplete && newPass == "")}>
            {notMatched
              ? "password does not match"
              : incomplete && newPass == ""
              ? "required"
              : ""}
          </FormHelperText>
        </Grid>
        <Grid item xs={12}>
          <InputLabel
            error={notMatched || (incomplete && confirmPass == "")}
            htmlFor="outlined-basic-confirm"
            sx={{ textAlign: "left" }}
          >
            Confirm Password
          </InputLabel>
          <OutlinedInput
            error={notMatched || (incomplete && confirmPass == "")}
            id="outlined-basic-confirm"
            onChange={(e) => {
              setConfirmPass(e.target.value);
            }}
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPass}
            defaultValue={confirmPass}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => {
                    setShowConfirmPassword(!showConfirmPassword);
                  }}
                  onMouseDown={() => {}}
                  edge="end"
                >
                  {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            sx={{ width: "50vh" }}
          />
          <FormHelperText
            error={notMatched || (incomplete && confirmPass == "")}
          >
            {notMatched
              ? "password does not match"
              : incomplete && confirmPass == ""
              ? "required"
              : ""}
          </FormHelperText>
        </Grid>
        <Grid item xs={12}>
          <Button
            disabled={notMatched}
            variant="contained"
            style={{
              backgroundColor: "#f26522",
              color: "white",
              width: "20vh",
            }}
            onClick={handleSave}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default ChangePassword;
